document.addEventListener("DOMContentLoaded", function () {
  const track = document.getElementById("carouselTrack");
  const slides = document.querySelectorAll(".carousel-slide");
  const prevBtn = document.querySelector(".carousel-prev");
  const nextBtn = document.querySelector(".carousel-next");
  const paginationDots = document.querySelectorAll(".pagination-dot");

  let currentIndex = 0;
  let touchStartX = 0;
  let touchEndX = 0;
  let isDragging = false;

  const slidesToShow = () => {
    if (window.innerWidth > 1024) return 3;
    if (window.innerWidth > 768) return 2;
    return 1;
  };

  const updateCarousel = () => {
    const slideWidth = track.parentElement.clientWidth;
    const gap = 20;
    const offset = currentIndex * (slideWidth / slidesToShow() + gap);
    track.style.transform = `translateX(-${offset}px)`;

    // Update pagination
    paginationDots.forEach((dot, idx) => {
      dot.classList.toggle("active", idx === currentIndex);
    });

    // Buttons are always enabled for infinite loop
    prevBtn.disabled = false;
    nextBtn.disabled = false;
  };

  const moveToPrev = () => {
    currentIndex--;
    if (currentIndex < 0) {
      currentIndex = slides.length - slidesToShow();
    }
    updateCarousel();
  };

  const moveToNext = () => {
    if (currentIndex >= slides.length - slidesToShow()) {
      currentIndex = 0;
    } else {
      currentIndex++;
    }
    updateCarousel();
  };

  const moveToSlide = (index) => {
    currentIndex = Math.max(0, Math.min(index, slides.length - slidesToShow()));
    updateCarousel();
  };

  // Button events
  prevBtn.addEventListener("click", moveToPrev);
  nextBtn.addEventListener("click", moveToNext);

  // Pagination events
  paginationDots.forEach((dot, idx) => {
    dot.addEventListener("click", () => moveToSlide(idx));
  });

  // Touch/Swipe events
  track.addEventListener(
    "touchstart",
    (e) => {
      touchStartX = e.changedTouches[0].screenX;
      isDragging = true;
    },
    false,
  );

  track.addEventListener(
    "touchend",
    (e) => {
      touchEndX = e.changedTouches[0].screenX;
      isDragging = false;
      handleSwipe();
    },
    false,
  );

  const handleSwipe = () => {
    const swipeThreshold = 50;
    const diff = touchStartX - touchEndX;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        moveToNext();
      } else {
        moveToPrev();
      }
    }
  };

  // Keyboard navigation
  document.addEventListener("keydown", (e) => {
    if (e.key === "ArrowLeft") moveToPrev();
    if (e.key === "ArrowRight") moveToNext();
  });

  // Responsive update
  window.addEventListener("resize", updateCarousel);

  // Initial setup
  updateCarousel();
});
